import React, { useState } from "react";
import { Check, Ticket, X } from "lucide-react";
import { useCart } from "../context/CartContext";

// Pole na kod rabatowy — używane w koszyku i na stronie zamówienia
export function DiscountBox({ testidPrefix = "discount" }) {
  const { discount, discountAmount, applyCode, removeCode, items } = useCart();
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!value.trim() || busy) return;
    setBusy(true);
    const ok = await applyCode(value.trim());
    setBusy(false);
    if (ok) setValue("");
  };

  if (discount) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-3.5 py-2.5" data-testid={`${testidPrefix}-applied`}>
        <div className="flex min-w-0 items-center gap-2.5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-300"><Check className="h-4 w-4" /></span>
          <div className="min-w-0">
            <div className="truncate font-mono text-sm font-bold text-emerald-200">{discount.code}</div>
            <div className="text-[11px] text-emerald-300/80">Rabat −{discount.percent}%{items.length ? ` · oszczędzasz ${discountAmount.toFixed(2)} zł` : ""}</div>
          </div>
        </div>
        <button type="button" onClick={removeCode} data-testid={`${testidPrefix}-remove`} className="rounded-lg p-1.5 text-slate-400 transition-colors hover:text-rose-400" aria-label="Usuń kod rabatowy">
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-2" data-testid={`${testidPrefix}-form`}>
      <div className="relative min-w-0 flex-1">
        <Ticket className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        <input
          data-testid={`${testidPrefix}-input`}
          value={value}
          onChange={(e) => setValue(e.target.value.toUpperCase())}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); submit(); } }}
          placeholder="Kod rabatowy"
          autoCapitalize="characters"
          autoComplete="off"
          spellCheck={false}
          className="w-full rounded-xl border border-slate-700 bg-slate-900 py-2.5 pl-9 pr-3 font-mono text-sm tracking-wider text-slate-200 placeholder:font-sans placeholder:tracking-normal placeholder:text-slate-500 outline-none transition-colors focus:border-cyan-500"
        />
      </div>
      <button
        type="button"
        onClick={submit}
        data-testid={`${testidPrefix}-apply`}
        disabled={busy || !value.trim()}
        className="shrink-0 rounded-xl border border-cyan-400/40 bg-cyan-400/10 px-4 py-2.5 text-sm font-bold text-cyan-200 transition-all hover:bg-cyan-400/20 active:scale-95 disabled:opacity-40"
      >
        {busy ? "..." : "Zastosuj"}
      </button>
    </div>
  );
}
